import {getStickers} from '../../services/api/stickers';
import {getCurrentLocale} from '../../utils/i18n';

export const STICKER_LOAD_START = 'STICKER_LOAD_START';
export const STICKER_LOAD_ERROR = 'STICKER_LOAD_ERROR';
export const STICKER_LOAD_COMPLETE = 'STICKER_LOAD_COMPLETE';

export const loadStickers = () => async dispatch => {
    const lang = getCurrentLocale();
    dispatch({type: STICKER_LOAD_START});

    try {
        let packs = await getStickers(lang);
        dispatch({type: STICKER_LOAD_COMPLETE, packs});
    } catch (error) {
        console.log(error);
        dispatch({type: STICKER_LOAD_ERROR, error});
    }
};
